const COUNT_LIMIT = 10;

export const getNotificationsLimitCount = (unreadCount: number | null) => {
  if (unreadCount === null) {
    return null;
  }

  return unreadCount > COUNT_LIMIT ? `${COUNT_LIMIT}+` : unreadCount;
};
